import headerAnalytics from 'header.analytics';
import headerData from 'header.data';
import headerDDFlyout from 'header.dropdownmodule';
import Mustache from 'mustache';
import utils from '../shared/utils';
import '../shared/sv-hover-intent';

const flyoutHS = {};
flyoutHS.templates = {};

flyoutHS.templates.hslist = headerDDFlyout.templates.diyandhs;

flyoutHS.getFlyoutData = function getFlyoutData() {
  const jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/hsflyout.json';
  const responseDataPromise = headerData.getEtchJSON(jsonPath);

  responseDataPromise.then(function _responseDataPromise(hsData) {
    const htmlContent = Mustache.render(flyoutHS.templates.hslist, hsData.hsflyout);

    utils.setInnerHtml('.hsFlyout', htmlContent);
  });
};

flyoutHS.triggerHoverintent = function _triggerHoverIntent(targetElement) {
  targetElement.dispatchEvent(new Event('hoverintent'));
};

// bind to all the necessary elements
flyoutHS.initialize = function initialize() {
  if (headerData.isDropDown()) {
    // delegate to all the things
    utils.addListenersToAll(['click', 'touchend', 'hoverintent'],
      '.Header3 .ShoppingLinks__link[data-id="homeServices"]', flyoutHS.getFlyoutData);
    
    new SV.HoverIntent(document.querySelectorAll('.Header3 .ShoppingLinks__link[data-id="homeServices"]'),
      {
        onEnter: (targetElement) => {
          flyoutHS.triggerHoverintent(targetElement);
        },
        onExit: () => {}
      })
    
    utils.delegateListeners(['click', 'touchend'],
      '#hsFlyout .content_image a', flyoutHS.logInteractionforImg);
    utils.delegateListeners(['click', 'touchend'], '#hsFlyout .cta__text', flyoutHS.logInteractionforL2);
    utils.delegateListeners(['click', 'touchend'],
      '#hsFlyout .diyFlyout__level3link', flyoutHS.logInteractionforL3);
  }
};

flyoutHS.logInteractionforL3 = function _logInteractionforL3() {
  const level2 = this.closest('.content')?.querySelector('.cta__text')?.innerText;
  const level3 = this.innerText.toLowerCase()
  return flyoutHS.logEventPath('header click', [level2, level3]);
};

flyoutHS.logInteractionforL2 = function _logInteractionforL2() {
  const level2 = this.innerText.toLowerCase();
  return flyoutHS.logEventPath('header click', [level2]);
};

flyoutHS.logInteractionforImg = function _logInteractionforImg() {
  const level2 = this.getAttribute('alt');
  return flyoutHS.logEventPath('header click', [level2]);
};

flyoutHS.logEventPath = function _logEventPath(type, pathArray) {
  // Get header at the beginning, then join them all
  const level1 = document.querySelector('.Header3 .ShoppingLinks__link[data-id="homeServices"]')?.innerText;
  return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
};

/*
  * Public Methods
  */

flyoutHS.init = function init() {
  flyoutHS.initialize();
  headerData.init();

  return this;
};

export default flyoutHS;
